// extracted by mini-css-extract-plugin
export default {"carousel__wrapper":"BF","carousel__wrapper_on_sides":"CF","arrows_wrapper":"EF","arrows_wrapper_right":"FF","arrows_wrapper_vertical":"GF","arrows_wrapper_on_sides":"HF","arrow_button":"IF","carousel_arrow_left":"JF","carousel_arrow_left_on_side":"KF","carousel_arrow_right_on_side":"LF","carousel_arrow":"MF","arrows_wrapper_rounded":"NF","carousel__fullWidth":"OF"};
    if(module.hot) {
      // 1743628927208
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  